module.exports = __webpack_public_path__ + "static/media/mdi--aws.64407d01.png";